<template>
	<!-- con il mouse sopra lo scorrimento automatico si ferma; su telefono e tablet non si mostra -->
	<v-card v-if="visibile" flat class="promo-slides mb-3 overflow-hidden rounded-lg" @mouseenter="paused = true" @mouseleave="paused = false">
		<v-carousel
			v-model="current"
			height="300"
			:show-arrows="slides.length > 1"
			show-arrows-on-hover
			:hide-delimiters="slides.length < 2"
			hide-delimiter-background
			delimiter-icon="mdi-minus"
		>
			<v-carousel-item v-for="slide in slides" :key="slide._id">
				<!-- altezza fissa 300px, larghezza naturale dell'immagine: niente adattamento alla larghezza -->
				<div class="promo-slide">
					<img
						:src="slide.image"
						:alt="slide.title || 'Promo'"
						:class="{ 'promo-link': !!slide.link }"
						:role="slide.link ? 'link' : undefined"
						@click="apri(slide)"
					/>
				</div>
			</v-carousel-item>
		</v-carousel>
	</v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { isExternalLink, isValidLink } from '@/components/manage/promoslides/link';

// Ogni quanto passa alla slide successiva
const INTERVALLO_MS = 6000;

// Slide promo gestite dal SuperAdmin in Gestione > Slide promo: se non ce ne
// sono di attive il componente non occupa spazio.
// Lo scorrimento automatico e' gestito qui e non con `cycle` di v-carousel: in
// Vuetify 2.6 restartTimeout passa da requestAnimationFrame e puo' lasciare un
// timer orfano che fa avanzare la slide anche con il mouse sopra.
export default {
	name: 'PromoSlides',
	data() {
		return {
			current: 0,
			paused: false,
			timer: null,
		};
	},
	computed: {
		...mapGetters({
			slides: 'promoslides/getActive',
		}),
		// sotto il breakpoint md (telefono/tablet) la slide 1024x300 verrebbe tagliata: non si mostra
		visibile() {
			return this.slides.length > 0 && this.$vuetify.breakpoint.mdAndUp;
		},
	},
	watch: {
		// cambio slide (anche dalle frecce), pausa o nuova lista: il conteggio riparte da zero
		current: 'programma',
		paused: 'programma',
		visibile: 'programma',
		slides() {
			if (this.current >= this.slides.length) this.current = 0;
			this.programma();
		},
	},
	created() {
		this.$store.dispatch('promoslides/fetchActive');
	},
	beforeDestroy() {
		clearTimeout(this.timer);
	},
	methods: {
		programma() {
			clearTimeout(this.timer);
			this.timer = null;
			if (!this.visibile || this.paused || this.slides.length < 2) return;
			this.timer = setTimeout(() => {
				this.current = (this.current + 1) % this.slides.length;
			}, INTERVALLO_MS);
		},
		apri(slide) {
			const link = String(slide.link || '').trim();
			if (!link || !isValidLink(link)) return;
			if (isExternalLink(link)) {
				window.open(link, '_blank', 'noopener');
				return;
			}
			if (this.$route.fullPath === link) return;
			// NavigationDuplicated/redirect dei guard: non sono errori da mostrare
			this.$router.push(link).catch(() => {});
		},
	},
};
</script>

<style scoped>
.promo-slide {
	height: 300px;
	display: flex;
	justify-content: center;
	overflow: hidden;
}

.promo-slide img {
	height: 100%;
	width: auto;
	max-width: none;
	flex: 0 0 auto;
	display: block;
}

.promo-link {
	cursor: pointer;
}
</style>
